module.exports = __webpack_public_path__ + "static/media/dice-d6.ac258d31.svg";